export default __webpack_public_path__ + "static/media/ceramol-iage-intelligent-tip-background.236066b0.png";